import { Tabs, theme } from "antd";
import { PaginationList } from "Explore/Components";
import VenueTopInstitutions from "../VenueTopInstitutions/VenueTopInstitutions";
import VenueTopPapers from "../VenueTopPapers/VenueTopPapers";
import VenueTopScholars from "../VenueTopScholars/VenueTopScholars";
import styles from "./AcademicInformation.module.scss";
import StickyBox from "react-sticky-box";
import useDeviceCheck from "Hooks/useDeviceCheck";
const AcademicInformation = ({
  disabledInfomation,
  topInstitutions,
  topScholars,
  tab,
  setTab,
  pagination,
  setPagination,
  venueId,
  timeFilter,
  selectedKeywords,
}) => {
  const { isMobile } = useDeviceCheck();
  const tabs = [
    {
      label: "Top Scholars",
      key: "topScholars",
      children: VenueTopScholars,
      data: topScholars.data,
      isLoading: topScholars.isLoading,
      disabled: !disabledInfomation.has_top_authors,
    },
    {
      label: "Top Institutions",
      key: "topInstitutions",
      children: VenueTopInstitutions,
      data: topInstitutions.data,
      isLoading: topInstitutions.isLoading,
      disabled: !disabledInfomation.has_top_institutions,
    },
    {
      label: "Notable Scholarly Works",
      key: "topPapers",
      disabled: !disabledInfomation.has_top_papers,
    },
  ];
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const renderTabBar = (props, DefaultTabBar) => (
    <StickyBox
      offsetTop={0}
      offsetBottom={20}
      style={{
        zIndex: 1,
      }}
    >
      <DefaultTabBar
        {...props}
        style={{
          background: colorBgContainer,
        }}
      />
    </StickyBox>
  );

  const onChange = (key) => {
    setTab(key);
    setPagination({
      ...pagination,
      page: 1,
      rowsPerPage: 10,
    });
  };
  return (
    <div className={styles["academic-information"]}>
      <Tabs
        onChange={onChange}
        items={tabs.map((item) => {
          return {
            label: item.label,
            key: item.key,
            disabled: item.disabled,
            children:
              item.key === "topPapers" ? (
                // Self-contained: manages its own pagination via useInfinityPagination.
                <VenueTopPapers
                  venueId={venueId}
                  timeFilter={timeFilter}
                  keywords={selectedKeywords}
                />
              ) : (
                <item.children
                  data={item.data}
                  isLoading={item.isLoading}
                  pagination={pagination}
                />
              ),
          };
        })}
        {...(isMobile
          ? {
              className: styles["tabs-mobile__wrapper"],
              renderTabBar,
              type: "line",
            }
          : { type: "card" })}
      />
      {/* Top papers has its own (infinity) paginator inside the tab. */}
      {tab !== "topPapers" && (
        <PaginationList
          pagination={pagination}
          setPagination={setPagination}
          sizeChanger={true}
        />
      )}
    </div>
  );
};

export default AcademicInformation;
